import request from '../request'

//查询 用户 焕新币 余额接口
export function queryUserAmountApi(params){
    return request({
        url:'/live/wallet/get/wallet/balance',
        method:'get',
        params,
    })
}

//用户 打赏 接口
export function daShangApi(data){
    return request({
        url:'/live/wallet/reward',
        method:'post',
        data,
    })
}

//用户 充值记录 接口
export function payLogApi(params){
    return request({
        url:'/live/wallet/charge/page',
        method:'get',
        params,
    })
}

//用户 充值退款 接口
export function payRefoundApi(data){
    return request({
        url:'/live/wallet/refund',
        method:'post',
        data,
    })
}

//充值 获取充值二维码 接口
export function getPayQrcodeApi(data){
    return request({
        url:'/live/order/pay/per/order',
        method:'post',
        data,
    })
}

//查询 充值 是否成功 接口
export function queryPayResultApi(orderSn){
    return request({
        url:'/live/order/pay/query/pay/result/' + orderSn,
        method:'get',
        params: {},
    })
}



// WEBPACK FOOTER //
// ./src/api/apis/liveUser.js